import { forwardRef, type Ref, type SVGProps } from "react";
const IconChecklistFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26 2H6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M13 25h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m1.73-8.83-2.86 3a.87.87 0 0 1-1.3 0l-1.3-1.38a1 1 0 0 1 0-1.38.88.88 0 0 1 1.3 0l.65.69 2.21-2.36a.9.9 0 0 1 1.3 0 1 1 0 0 1 0 1.43m0-7-2.86 3a.87.87 0 0 1-1.3 0l-1.3-1.38a1 1 0 0 1 0-1.38.88.88 0 0 1 1.3 0l.65.69 2.21-2.36a.9.9 0 0 1 1.3 0 1 1 0 0 1 0 1.43M22 25h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2m0-6h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2m0-7h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2" />
  </svg>
);
const ForwardRef = forwardRef(IconChecklistFilledSVG);
ForwardRef.displayName = "IconChecklistFilled";
export { ForwardRef as IconChecklistFilled };
